// Copyright (c) 2016 Deere & Company

import AllClaimsContainer from '../../claim/all-claims/state-connector';
export default {
    component: AllClaimsContainer,
    name: 'CLAIMS_OVERVIEW',
    path: 'all'
};



// WEBPACK FOOTER //
// ./src/routes/claims/all-claims.js